<template>
  <div class="mainChild page-content" id="lowPriceDetails">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item>违规检索数据统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="headerBrand">
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="商品标题" :label-width="formLabelWidth">
            <el-input clearable placeholder="请输入商品标题" v-model="list.itemtitle" size="small"></el-input>
          </el-form-item>
          <el-form-item label="平台" :label-width="formLabelWidth">
            <el-select v-model="list.platform" filterable clearable placeholder="请选择" size="small">
              <el-option label="淘宝天猫" value="TBTM"></el-option>
              <el-option label="淘宝" value="TB"></el-option>
              <el-option label="天猫" value="TM"></el-option>
              <el-option label="京东" value="JD"></el-option>
              <el-option label="苏宁" value="SN"></el-option>
              <el-option label="1688" value="1688"></el-option>
              <el-option label="拼多多" value="PDD"></el-option>
              <el-option label="当当" value="DD"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入店铺名称" v-model="list.shopname" size="small"></el-input>
          </el-form-item>
          <el-form-item label="产品信息" :label-width="formLabelWidth">
            <el-input
              :clearable="true"
              placeholder="请输入产品信息"
              v-model="list.productName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="日期" :label-width="formLabelWidth">
            <el-date-picker
              v-model="searchformDate"
              type="daterange"
              start-placeholder="请选择"
              end-placeholder="请选择"
              range-separator="~"
              :picker-options="pickerOptions"
              size="small"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="margin-top: 4px;">
            <el-button size="small" class="search-btn" @click="getIprPluginListList(1)">查  询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="downContainer">
      <div class="downBtn">
        <el-button size="small" type="primary" :loading="lowPriceLoading" @click="downTable">下载数据</el-button>
        <el-button size="small" @click="batchOutage()">批量导入</el-button>
        <el-button size="small" @click="exportExcel">下载模板</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
          共
        <span v-show='showType'>
          <span class="promptFont">{{total}}</span>项
        </span>
        <span v-show='!showType'>{{total}}  项违规商品，检索数据时间：{{$route.query.date}}。</span>
      </div>
      <!--表格-->
      <el-table
        ref="multipleTable"
        :data="tableList"
        style="width: 100%"
        v-loading="tableLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="序号" align="left" width="50">
          <template slot-scope="scope">
            {{scope.$index | indexMethod(list.pageNo,list.pageSize)}}
          </template>
        </el-table-column>
        <el-table-column label="商品信息" prop="itemtitle" width="480">
          <template slot-scope="scope" class="shopInfo">
            <div class="shopMain">
              <img :src="scope.row.logopicurl_details?scope.row.logopicurl_details:scope.row.logopicurl" alt/>
              <div class="content">
                <el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
                  {{scope.row.itemtitle_details?scope.row.itemtitle_details:scope.row.itemtitle}}
                </el-link>
                <div class="align_left">
                  {{scope.row.productname}}
                </div>
                <el-button type="primary" size="mini" plain @click="skuListChildShow(scope.row.itemid,scope.row.synchrotime)" v-show="scope.row.itemtype == 2" style="margin-top: 5px">
                  SKU列表
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="价格"  width="200">
          <template slot-scope="scope">
            <div style="float: left;width: 100%;">
              <div v-if="scope.row.price" style="float: left;">标价：¥ {{scope.row.price}}</div>
              <div v-if="scope.row.islowprice == '是'" class="redClass2" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
              <div v-if="scope.row.checkprice" style="float: left;">标价限价：¥ {{scope.row.checkprice}}</div>
            </div>
            <div style="float: left;;width: 100%;">
              <div v-if="scope.row.contrastprice || scope.row.availableprice != '0.0'" style="float: left;">
                到手价：¥ {{scope.row.availableprice}}
              </div>
              <div v-if="scope.row.availableislowprice == '是'" style="width: 51px;float: right;margin: 3px 10px;" class="redClass2">
                到手低
              </div>
              <div v-if="scope.row.availablecheckprice" style="float: left;">
                到手限价：¥ {{scope.row.availablecheckprice}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="优惠说明" width="320">
          <template slot-scope="scope" v-if="scope.row.coupons">
            <couponsZzj :zzjCoupons="scope.row.coupons.split(',')"/>
          </template>
        </el-table-column>
        <el-table-column label="店铺信息"  width="320" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.shopname" class="align_left ellipsis">{{scope.row.shopname}}</div>
            <div v-else class="align_left ellipsis">/</div>
            <div v-show="scope.row.wangwang" class="align_left ellipsis">{{scope.row.wangwang}}</div>
            <div class="tall_icon">
              <img
                :src="require('@/assets/img/platform/pla_'+scope.row.platform+'.png')"
                alt
                class="edit_icon"
              />
              <span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <span class="grey" v-show="scope.row.shoptype=='灰名单'">灰</span>
              <span class="black" v-show="scope.row.shoptype=='黑名单'">黑</span>
              <span class="green" v-show="scope.row.shoptype== '授权店铺'">授权</span>
            </div>
            <div class="align_left ellipsis">{{scope.row.dealername}}</div>
          </template>
        </el-table-column>
        <el-table-column label="产品编号" width="320">
          <template slot-scope="scope">
          {{scope.row.productid}}
          </template>
        </el-table-column>
        <el-table-column
          v-for="colItem in tableAdd"
  		    :prop="colItem.fieldvalue"
          :label="colItem.fieldname"
           width="200"
        >
          <template slot-scope="scope">
            {{JSON.parse(scope.row.add_field)[colItem.fieldvalue]}}
          </template>
        </el-table-column>
        <el-table-column label="数据更新时间" width="200px"  fixed="right" class-name="lastTime">
          <template slot="header" slot-scope="scope">
            数据更新时间
            <i class="el-icon-setting" style="color: #409EFF;margin-left: 74px;cursor: pointer;" @click="setTableTitle"></i>
          </template>
          <template slot-scope="scope">
            <span v-show="scope.row.synchrotime">{{scope.row.synchrotime}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <pagination
        v-if="tableList&&tableList.length>0"
        :currentPage="currentPage"
        :pageSizes="[10, 20, 50, 100]"
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>

    <!-- sku信息 -->
    <el-dialog :visible.sync="skuShow" width="70%" title="SKU列表" id="elDialog">
      <el-table :data="skuData" style="width: 100%"
      v-loading="skuloading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading">
        <el-table-column label="序号" align="left" type="index" width="50">
          <template slot-scope="scope">
            {{scope.$index | indexMethod(list.pageNo,list.pageSize)}}
          </template>
        </el-table-column>
        <el-table-column prop="skuname" label="SKU名称">
          <template slot-scope="scope">
            <div class="skuname">{{scope.row.skuname}}</div>
          </template>
        </el-table-column>
        <el-table-column label="价格">
          <template slot-scope="scope">
            <div style="float: left;width: 100%;">
              <div v-if="scope.row.price" style="float: left;width: 100%;">标价：¥ {{scope.row.price}}</div>
              <div v-if="scope.row.islowprice == '是'" class="redClass2" style="width: 39px;float: left;">标低</div>
              <div v-if="scope.row.checkprice" style="float: left;width: 100%;">标价限价：¥ {{scope.row.checkprice}}</div>
            </div>
            <div style="float: left;;width: 100%;">
              <div v-if="scope.row.availableprice" style="float: left;width: 100%;">
                到手价：¥ {{scope.row.availableprice}}
              </div>
              <div v-if="scope.row.availableislowprice == '是'" style="width: 51px;float: left;" class="redClass2">
                到手低
              </div>
              <div v-if="scope.row.availablecheckprice" style="float: left;width: 100%;">
                到手限价：¥ {{scope.row.availablecheckprice}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品">
          <template slot-scope="scope">
            <div class="productname">
              <span v-if="scope.row.productid">
                <span v-if="scope.row.productid.length > 20">{{scope.row.productName}}</span>
                <span v-else>限价标准：¥{{scope.row.productid}}</span>
              </span>
              {{scope.row.productname}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-if="tableList&&tableList.length>0"
        :currentPage="currentPage2"
        :pageSizes="[10, 20, 50, 100]"
        :total="total2"
        @handleSizeChange="handleSizeChange2"
        @handleCurrentChange="handleCurrentChange2"
      ></pagination>
    </el-dialog>


    <!-- 设置表头弹框 -->
    <setTableTitle :modalInfo="setModalInfo"  @reqTableData="reqTableData"  ref="setModal" :numType="4"/>
    <el-dialog title="批量导入"
      class="importModal"
      :visible.sync="BulkImportShow"
      :close-on-click-modal="false"
      width="640px"
      style="margin-top: 10%;" id="dialog">
      <div class="wrap" style="margin: 10px;">
        <el-upload
          ref="newupload"
          class="upload-demo"
          drag
          action="hcm/IprPluginLowPriceStatistics/readExcelFile"
          :auto-upload="false"
          multiple
          :before-upload="beforeUpload"
          accept=".xls,.xlsx"
          :on-success="confirmUpload"
          >
          <i class="el-icon-upload" style="color: #BDA571;"></i>
          <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
            <br>
            <span style="font-size: 14px;color: #d4d4d4;">
              支持扩展名：.xls .xlsx
            </span>
          </div>
        </el-upload>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
        <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagination from "../../components/dataTable/pagination";
import aes from "@/libs/aes";
import setTableTitle from "components/setTableTitle";  //设置表头
import { renderShopName ,renderProductInfo} from "@/libs/renderCommon";
import { fetchGet } from "@/libs/reqCommon";
export default {
  name: "brandStore",
  data() {
    return {
      tableAdd: [],
      bulLoading: false,
      BulkImportShow: false,
      searchformDate: [],
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick:(picker) => {
            this.getRecentDate(picker,1);
          }
        },{
          text: '近7日',
          onClick:(picker) => {
            this.getRecentDate(picker,7);
          }
        }, {
          text: '近15日',
          onClick:(picker) => {
            this.getRecentDate(picker,15);
          }
        }, {
          text: '近30日',
          onClick:(picker) => {
            this.getRecentDate(picker,30);
          }
        }, {
          text: '近90日',
          onClick:(picker) => {
            this.getRecentDate(picker,90);
          }
        }, {
          text: '近365日',
          onClick:(picker) => {
            this.getRecentDate(picker,365);
          }
        }]
      },
      productid: [],
      options2: [],
      cascaderDisabled: false,
      productidChildren: {
        multiple: true,
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      skuloading: true,
      lowPriceLoading: false,
      toPath:{ path: '/Brand/BrandMerchandise/lowPriceSearch' },
      pageNo: 1,
      pageSize: 10,
      currentPage2: 1,
      total2: 1,
      itemid: "",
      skuData: [],
      skuShow: false,
      tableLoading: false,
      multipleSelection: [],
      deleteShow: false,
      checkAll: 0,
      openNumber: 0,
      logintype: "",
      numberOf: "该",
      platformCode: "TBTM",
      dictCodeShow: "TB",
      platformShow: true,
      formLabelWidth: "100px",
      tableList: [],
      currentPage: 1,
      total: "",
      batchUserIds: "",
      list: {
        pageNo: 1,
        pageSize: 10,
        platform: '',
        // starttime: this.$route.query.date.substring(0,this.$route.query.date.length - 9),
        itemtitle: "",
        shopname: "",
        productName: "",
        remark: "",
      },
      showType:true,
      newplatCode: '',
      setModalInfo:{},//设置表头弹框属性
    };
  },
  components: {
    pagination,setTableTitle
  },
  filters: {
    stringArray: function(value) {
      if (value) {
        let newValue;
        newValue = value.substr(0, value.length - 1);
        return newValue.substr(1, value.length - 1).split(",");
      }
    },
    objToAr: aes.objToArr
  },
  mounted() {
    this.getBybmcidAndModule();
  },
  computed: {},
  methods: {
    // 取消
    BulkImportShowf() {
      this.BulkImportShow = false
      this.$refs.newupload.clearFiles();
    },
    // 确认上传
    BulkImport() {
      this.bulLoading = true
      this.$refs.newupload.submit();
    },
    // 上传前
    beforeUpload(file) {
      let Xls = file.name
      if(Xls.search("xls") != -1 || Xls.search("xlsx") != -1){
        return file
      }else {
        this.$message.error('上传文件只能是 xls/xlsx 格式!')
        return false
      }
    },
    // 上传成功
    confirmUpload(response) {
      console.log(1111111111)
      console.log(response)
      if (response.status == 10000) {
        this.$refs.newupload.clearFiles();
        this.$message({
          message: response.message,
          type: 'success'
        });
        this.bulLoading = false
        this.getIprPluginListList();
        this.BulkImportShow = false
      } else {
        this.bulLoading = false
        this.getIprPluginListList();
        this.BulkImportShow = false
        this.$message.error(response.message);
        this.$refs.newupload.clearFiles();
      }
    },
    // 触发上传
    batchOutage() {
      this.BulkImportShow = true
    },
    exportExcel() {
      fetch({
        url: "hcm/IprPluginLowPriceStatistics/exportExcel",
        method: "get",
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 5
      })
      .then((res)=>{
        //下载
        let url = window.URL.createObjectURL(new Blob([res]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '违规检索数据导入模板.xlsx')
        document.body.appendChild(link)
        link.click()
        this.downloadLoading = false
      })
    },
    // 设置表头
    setTableTitle(){
      this.setModalInfo = {isShow:true}
      this.$refs.setModal.getFildData('DAILYLOW')
    },
    reqTableData(){
      this.initTableColum();
    },
    initTableColum(){
      let query = { module:"DAILYLOW"}
      fetchGet("/hcm/hcmCustomModel/getBybmcidAndModule",query).then(res =>{
        this.gridColumns = [];this.basicField=[];this.addField=[];
        if(res.status == "10000"){

        }
      });
      this.getBybmcidAndModule();
    },
    getRecentDate(picker,n){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if(picker){
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.searchformDate[0] = end;
        this.searchformDate[1] = end;
      } else {
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
      }
    },
    handleChange(value) {
      this.productid = value
    },
    getListBybmcid2(data) {
      if (data == true && this.options2.length == 0) {
        this.cascaderDisabled = true
        fetch({
          url: "hcm/hcmProduct/getListBybmcid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.options2 = result.data;
            this.cascaderDisabled = false
          }
        });
      }
    },
    // 下载
    downTable() {
      this.lowPriceLoading = true
      let datas = {};
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          datas.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10);
        }
      }
      if (this.list.platform) {
        datas.platform = this.list.platform;
      }
      if (this.list.itemtitle) {
        datas.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        datas.shopname = this.list.shopname;
      }
      if (this.list.remark) {
        datas.remark = this.list.remark;
      }
      if (this.list.productName) {
        datas.productName = this.list.productName;
      }
      fetch({
        url: "hcm/IprPluginLowPriceStatistics/exportExcelStatistics",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 5
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "违规检索数据统计.xlsx");
        document.body.appendChild(link);
        link.click();
        this.lowPriceLoading = false
      });
    },
    // 查询
    getIprPluginListList(e) {
      this.tableLoading = true
      if (e == 1) {
        this.list.pageNo = 1;
      }
      let datas = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
        platform: this.list.platform,
      };
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          datas.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10);
        }
      }
      if (this.list.itemtitle) {
        datas.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        datas.shopname = this.list.shopname;
      }
      if (this.list.remark) {
        datas.remark = this.list.remark;
      }
      if (this.list.productName) {
        datas.productName = this.list.productName;
      }
      fetch({
        url: "hcm/IprPluginLowPriceStatistics/getIprLowPriceStatisticsList",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.tableLoading = false
          this.tableList = data.content;
          this.total = data.totalElements;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getBybmcidAndModule() {
      let datas = {
        module: 'DAILYLOW'
      }
      fetch({
        url: "hcm/hcmCustomModel/getBybmcidAndModule",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.tableAdd = []
          if (res.data.add.data) {
            for (let a in res.data.add.data) {
              if (res.data.add.data[a].isChecked == 1) {
                this.tableAdd.push(res.data.add.data[a])
              }
            }
          }
          this.getIprPluginListList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // SKU列表
    skuListChildShow(itemid,synchrotime) {
      this.skuloading = true
      if (itemid) {
        this.itemid = itemid;
      }
      this.skuShow = true;
      let datas = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        itemid: this.itemid,
        syncDate: synchrotime
      };
      fetch({
        url: "hcm/IprPluginLowPriceStatistics/getIprLowPriceStatisticsSkuList",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.skuloading = false
          this.skuData = data.content;
          this.total2 = data.totalElements;
        } else {
          this.skuloading = false
          this.$message.error(res.message);
        }
      });
    },
    //每页
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getIprPluginListList();
    },
    //当前页
    handleCurrentChange(val) {
      this.list.pageNo = val;
      this.getIprPluginListList();
    },
    handleSizeChange2(val) {
      this.pageSize = val;
      this.skuListChildShow();
    },
    handleCurrentChange2(val) {
      this.pageNo = val;
      this.skuListChildShow();
    }
  }
};
</script>

<style lang="scss">
  @import "style/lowPriceDetails.scss";
</style>
